import { useQuery } from '@tanstack/react-query';
import { getEligibleCarCount } from '../api/api';
import type { PersonalFinanceEnvironment } from '../types';

export default function useEligibleCarCount(
  environment: PersonalFinanceEnvironment,
) {
  return useQuery({
    queryKey: ['eligibleCarCount', environment],
    queryFn: () => getEligibleCarCount(environment),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 2,
  });
}
